export default async function sequentialPromise(iterable, action) {
  // eslint-disable-next-line no-restricted-syntax
  for (const element of iterable) {
    // eslint-disable-next-line no-await-in-loop
    await action(element);
  }
}
